import {memo, useState, useRef, useEffect} from 'react';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import {Overlay, Tooltip} from 'react-bootstrap';

import {calcualteProductGoodCause, excludeGSTPrice} from '@utils/functions';
import {useApp} from '@context/AppProvider';
import Loading from '@components/Loading';
import {api} from '@utils/api';
const AgeValidatorModal = dynamic(() => import('@models/ageValidator.modal'));

const Item = props => {
	const {
		styles,
		data,
		state,
		dispatch,
		btFee,
		store,
		retailerCount,
		isWishlist = false,
		removeFromWishlist = () => {},
	} = props;
	//console.log(data);
	const [loader, setLoader] = useState(false);
	const [dataAge, setDataAge] = useState({
		isModalShow: false,
	});
	const {
		idb: {session, origin, user, isoCode},
		convertCurrency,
		showModel,
	} = useApp();
	const addToCart = () => {
		getProductDetails();
	};
	const ageCallback = isActive => {
		setDataAge(preState => ({
			...preState,
			isModalShow: false,
		}));
		if (!isActive)
			dispatch({
				type: 'SET_DATA',
				data: {
					showProductModal: true,
					modalData: dataAge.modalData,
				},
			});
	};
	const getProductDetails = async () => {
		try {
			setLoader(true);
			const result = await api(
				{
					url: `/product/${data.slug}/${store ? false : true}`,
					method: 'GET',
					params: store ? {slug: [store, data.slug]} : {},
				},
				session,
			);
			if (result.product?.retailers.length) {
				const ageActive = result.product?.retailers.find(
					item => item?.storeDetail?.isChecked,
				);

				if (
					ageActive?.storeDetail?.isChecked &&
					isoCode.toLowerCase() === 'nz'
				) {
					setDataAge(prev => ({
						...prev,
						isModalShow: true,
						modalData: {
							...result,
							queryParams: {},
							isBrand: false,
						},
					}));
				} else {
					dispatch({
						type: 'SET_DATA',
						data: {
							showProductModal: true,
							modalData: {
								...result,
								queryParams: {},
								isBrand: false,
							},
						},
					});
				}
			}
			setLoader(false);
		} catch (error) {
			setLoader(false);
		}
	};

	const getMaxAuction = auction => {
		const max = Math.max(...auction.map(o => o.base_price));
		return max;
	};
	return (
		<div className={`customCol ${isWishlist && 'wishlistCOl'}`}>
			<div className={`${styles.listingCard} borderBox borderBoxsAuction`}>
				<div className={styles.listCardTwoColumn}>
					<div className={`${styles.listingCardImg} pad15`}>
						{!isWishlist && <WishListBlock props={props} />}
						{window.innerWidth > 991 ? (
							<ImageBlock
								styles={styles}
								data={data}
								addToCart={addToCart}
								loader={loader}
								isWishlist={isWishlist}
							/>
						) : (
							<Link href={data.url} passHref>
								<a>
									<ImageBlock
										styles={styles}
										data={data}
										addToCart={addToCart}
										isWishlist={isWishlist}
									/>
								</a>
							</Link>
						)}
						<GoodCause
							styles={props.styles}
							value={calcualteProductGoodCause(
								convertCurrency(
									excludeGSTPrice(Number(data.price.buy), origin).toFixed(2),
									false,
									false,
								),
								btFee,
								state.goodCausePer,
								state.stripeFee,
								data.retailerData,
							)}
						/>
					</div>

					<Link href={data.url} passHref>
						<a className={styles.listingCardOuter}>
							<ListBlock
								styles={styles}
								data={data}
								origin={origin}
								retailerCount={retailerCount}
							/>
						</a>
					</Link>
					{dataAge.isModalShow && (
						<AgeValidatorModal isActive={true} callback={ageCallback} />
					)}
				</div>
				<span className={`${styles.priceInfo} ${styles.priceInfoDesktop}`}>
					{data?.auction?.length && data?.auctionPrice?.length ? (
						<div>
							<span className={styles.dropAuctionSell}>
								<span className={styles.dropAuctionText}>
									Selling for less than {''}
								</span>
								<span className={styles.mainPrice}>
									<span>
										{/* AUD $ */}
										{convertCurrency(
											Number(getMaxAuction(data.auctionPrice)).toFixed(2),
										)}
									</span>
								</span>
							</span>
						</div>
					) : (
						<div className={styles.priceBlock}>
							<div className={styles.mainPrice}>
								<span>
									<span>
										{convertCurrency(Number(data.price.buy).toFixed(2))}
									</span>
									{data.price.strike > data.price.buy && (
										<strong>
											{convertCurrency(Number(data.price.strike).toFixed(2))}
										</strong>
									)}
								</span>{' '}
								{data.price.strike > data.price.buy && (
									<div className={styles.strike}>
										{!!data.price.discount && (
											<span className={styles.discount}>
												{data.price.discount}% OFF
											</span>
										)}
									</div>
								)}
							</div>
						</div>
					)}
				</span>
			</div>
			{isWishlist && (
				<div className={styles.wishlistButtons}>
					{user ? (
						<>
							<AddToBag
								styles={styles}
								data={data}
								addToCart={addToCart}
								loader={loader}
							/>
							<button
								onClick={() => removeFromWishlist(data)}
								className={`${styles.btnCustom} ${styles.whiteBtn} mt-1`}
							>
								<i className='fa fa-trash pr-2'></i>REMOVE
							</button>
						</>
					) : (
						<>
							<button
								onClick={() => showModel('login')}
								className={`${styles.btnCustom} ${styles.btn_type3}`}
							>
								Login to Buy
							</button>
							<button
								onClick={() => removeFromWishlist(data)}
								className={`${styles.btnCustom} ${styles.whiteBtn} mt-1`}
							>
								<i className='fa fa-trash pr-2'></i>REMOVE
							</button>
						</>
					)}
				</div>
			)}
		</div>
	);
};

function ImageBlock({styles, data, addToCart, loader, isWishlist}) {
	const [image, setImage] = useState('/img/loading.png');
	useEffect(() => {
		setImage(data.image);
	}, [data.image]);
	return (
		<div className={styles.productImage}>
			<Image
				src={image}
				alt={data.name}
				layout='fill'
				objectFit='contain'
				placeholder='blur'
				blurDataURL='/img/loading.png'
				onError={e => {
					e.target.style['background-image'] = 'unset';
					setImage('/assets/svg/placeholder.svg');
				}}
			/>
			{window.innerWidth > 991 && !isWishlist && (
				<ImageHover
					styles={styles}
					data={data}
					addToCart={addToCart}
					loader={loader}
					isWishlist={isWishlist}
				/>
			)}
		</div>
	);
}

function ImageHover({styles, data, addToCart, loader}) {
	return (
		<div className={styles.imageHover}>
			<div className={styles.absolute}>
				<Link href={data.url} passHref>
					<div className={styles.overlay}></div>
				</Link>
				<div className={styles.buttonGroup}>
					<button
						onClick={addToCart}
						disabled={loader}
						className={`${styles.btnCustom} ${styles.btn_type1}`}
					>
						<span>Add to Bag</span>
						{loader && <Loading.LoaderThree />}
					</button>
					<Link href={data.url} passHref>
						<button className={`${styles.btnCustom} ${styles.btn_type2}`}>
							View More
						</button>
					</Link>
				</div>
			</div>
		</div>
	);
}

function WishListBlock({props}) {
	const {styles, data, addToWishlistOrRemove} = props;
	const [loader, setLoader] = useState(false);
	const [show, setshow] = useState(false);
	const target = useRef(null);
	const addOrRemoveWishlist = async () => {
		setshow(true);
		setLoader(true);
		await addToWishlistOrRemove(data);
		setLoader(false);
		setshow(false);
	};
	return (
		<div>
			<span className={styles.heartIcon}>
				<div>
					<button
						ref={target}
						onMouseEnter={() => setshow(true)}
						onMouseLeave={() => setshow(false)}
						onClick={addOrRemoveWishlist}
						className={
							data.wishlistData._id ? styles.heartButton : styles.bgHeart
						}
					>
						{loader ? (
							<Image
								layout='fixed'
								height={28}
								width={30}
								src={`/assets/svg/heartloader.gif`}
								alt='heart'
							/>
						) : (
							<Image
								layout='fixed'
								height={28}
								width={30}
								src={`/assets/images/${
									data.wishlistData._id ? 'heart' : 'heart-empty'
								}.svg`}
								alt='heart'
							/>
						)}
					</button>
					<Overlay
						target={target.current}
						show={show}
						placement='bottom'
						key='top'
					>
						{props => (
							<Tooltip id={data._id} {...props}>
								Wishlist
							</Tooltip>
						)}
					</Overlay>
				</div>
			</span>
		</div>
	);
}
function ListBlock({styles, data, retailerCount}) {
	const {convertCurrency} = useApp();

	const getMaxAuction = auction => {
		const max = Math.max(...auction.map(o => o.base_price));
		return max;
	};

	return (
		<div className={styles.listingCardInner}>
			<div className={styles.listingCardInfo}>
				<h2 className={styles.h2Heading}>
					<strong>{data.manufacturer}</strong>
				</h2>
				<h3 className='my-3'>
					<ProdutName productName={data.name} />
				</h3>
				<p className={styles.retailerInfo}>
					{retailerCount > 1
						? `From ${retailerCount} stores`
						: `From ${data.retailerData.shop_name}`}
				</p>

				{!!data.freeShipping && (
					<div className={styles.shippingBlockFree}>
						<span>Free Shipping</span>
						<div className={styles.icon}>
							<div className={styles.image}>
								<Image
									src='/assets/images/truck.png'
									alt='lockup'
									layout='fill'
								/>
							</div>
						</div>
					</div>
				)}
			</div>
			<span className={`${styles.priceInfo} ${styles.priceInfoMobile}`}>
				{data?.auction?.length && data?.auctionPrice?.length ? (
					<div>
						<span className={styles.dropAuctionSell}>
							<span className={styles.dropAuctionText}>
								Selling for less than {''}
							</span>
							<span className={styles.mainPrice}>
								<span>
									{/* AUD $ */}
									{convertCurrency(
										Number(getMaxAuction(data.auctionPrice)).toFixed(2),
									)}
								</span>
							</span>
						</span>
					</div>
				) : (
					<div className={styles.priceBlock}>
						<div className={styles.mainPrice}>
							<span>
								<span>
									{convertCurrency(Number(data.price.buy).toFixed(2))}
								</span>
								{data.price.strike > data.price.buy && (
									<strong>
										{convertCurrency(Number(data.price.strike).toFixed(2))}
									</strong>
								)}
							</span>{' '}
							{data.price.strike > data.price.buy && (
								<div className={styles.strike}>
									{!!data.price.discount && (
										<span className={styles.discount}>
											{data.price.discount}% OFF
										</span>
									)}
								</div>
							)}
						</div>
					</div>
				)}
			</span>
		</div>
	);
}
function GoodCause(props) {
	const {styles, value} = props;
	const [hover, setHover] = useState(false);
	const {convertCurrency} = useApp();
	const clickable = window?.innerWidth < 991 ? true : false;
	return (
		<>
			<span
				className={styles.lockupIcon}
				onMouseOver={() => !clickable && setHover(true)}
				onMouseOut={() => !clickable && setHover(false)}
				onClick={() => clickable && setHover(!hover)}
			>
				<div className={styles.lockupImg}>
					<Image
						src='/assets/images/lockupIcon.png'
						alt='lockup'
						layout='fill'
					/>
				</div>
			</span>
			<div
				className={`${styles.figureHover} ${
					hover && styles.figureShow
				} d-flex align-items-center justify-content-center pad15`}
			>
				<div className={styles.block}>
					<div className={`${styles.instFigure} ${styles.bgOvercast}`}>
						<p>Better That will donate</p>
						<p className={styles.hoverPrice}>
							{convertCurrency(
								value.gcAmount.toFixed(2),
								true,
								true,
								false,
								false,
							)}
						</p>
						<p>to your Good Cause</p>

						<p>if you buy this.</p>
					</div>
					{value.retailerGcAmount && (
						<div className={`${styles.instFigure} ${styles.bgPeach}`}>
							<p>{value.shop_name} will also donate</p>
							<p className={styles.hoverPrice}>
								{convertCurrency(
									value.retailerGcAmount.toFixed(2),
									true,
									true,
									false,
									false,
								)}
							</p>
							<p>to your Good Cause!</p>
						</div>
					)}
				</div>
			</div>
		</>
	);
}

function AddToBag({styles, data, addToCart, loader}) {
	return (
		<div className={styles.buttonGroup}>
			{data.total_stock && data.total_stock > 0 ? (
				<>
					<button
						onClick={addToCart}
						disabled={loader}
						className={`${styles.btnCustom} ${styles.btn_type2}`}
					>
						<span>ADD TO BAG</span>
						{loader && <Loading.LoaderThree />}
					</button>
				</>
			) : (
				<button
					disabled={loader}
					className={`${styles.btnCustom} ${styles.btn_type1}`}
				>
					<span>Out of Stock</span>
					{loader && <Loading.LoaderThree />}
				</button>
			)}
		</div>
	);
}

function ProdutName({productName}) {
	const [name, setName] = useState('');
	useEffect(() => {
		if (window.innerWidth > 1600) {
			setName(
				productName.length > 75
					? `${productName.substring(0, 75).trim()}... `
					: productName,
			);
		} else if (window.innerWidth > 1450 && window.innerWidth <= 1600) {
			setName(
				productName.length > 40
					? `${productName.substring(0, 40).trim()}... `
					: productName,
			);
		} else if (window.innerWidth > 1199 && window.innerWidth <= 1450) {
			setName(
				productName.length > 30
					? `${productName.substring(0, 30).trim()}... `
					: productName,
			);
		} else if (window.innerWidth > 991 && window.innerWidth <= 1199) {
			setName(
				productName.length > 45
					? `${productName.substring(0, 45).trim()}... `
					: productName,
			);
		} else if (window.innerWidth > 767 && window.innerWidth <= 991) {
			setName(
				productName.length > 45
					? `${productName.substring(0, 45).trim()}... `
					: productName,
			);
		} else if (window.innerWidth > 500 && window.innerWidth <= 767) {
			setName(
				productName.length > 55
					? `${productName.substring(0, 55).trim()}... `
					: productName,
			);
		} else if (window.innerWidth < 500) {
			setName(
				productName.length > 40
					? `${productName.substring(0, 40).trim()}... `
					: productName,
			);
		}
	}, [productName]);
	return <>{name}</>;
}

export default memo(Item);
